let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iP06G")).then(() => parcelRequire('jzTw0'));